import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=04e0d4a3&scoped=true"
import script from "./layout.js?vue&type=script&lang=js&external"
export * from "./layout.js?vue&type=script&lang=js&external"
import style0 from "./layout.vue?vue&type=style&index=0&id=04e0d4a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e0d4a3",
  null
  
)

export default component.exports